'use client';

import { c as _c } from "react/compiler-runtime";
import { type Upload } from '@shared/all/domains/uploads';
import classNames from 'classnames';
import { File } from 'lucide-react';
type Props = {
  data: Upload;
  inline?: boolean;
};
const DocumentItem = t0 => {
  const $ = _c(31);
  const {
    data,
    inline
  } = t0;
  let t1;
  if ($[0] !== data.name) {
    t1 = data?.name?.split(".").pop();
    $[0] = data.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const extension = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== data.display.key || $[3] !== data.display.url || $[4] !== data.name || $[5] !== extension || $[6] !== inline) {
    const fileName = data?.name?.replace(`.${extension}`, "");
    let t7;
    if ($[12] !== data.display.key || $[13] !== data.display.url) {
      t7 = () => {
        window.open(data.display.url || data.display.key, "_blank");
      };
      $[12] = data.display.key;
      $[13] = data.display.url;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const onClickHandler = t7;
    const t8 = !inline;
    if ($[15] !== inline || $[16] !== t8) {
      t4 = classNames("flex items-center p-2 cursor-pointer transition-colors duration-200 ease-in-out h- max-w-[120px] text-secondary", {
        "border border-ds-border-standard rounded mx-2 hover:bg-background-light": inline,
        "hover:bg-background-light": t8
      });
      $[15] = inline;
      $[16] = t8;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    t5 = onClickHandler;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <File />;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    t2 = "ml-2";
    t3 = data.name && <p className="truncate text-sm text-primary">{data.name.length < 20 ? data.name : `${fileName?.slice(0, 16)}...${extension}`}</p>;
    $[2] = data.display.key;
    $[3] = data.display.url;
    $[4] = data.name;
    $[5] = extension;
    $[6] = inline;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[19] !== data.display.key || $[20] !== data.name) {
    t7 = !data.name && <p className="text-sm text-primary">{data.display.key.slice(-4)}</p>;
    $[19] = data.display.key;
    $[20] = data.name;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t7) {
    t8 = <div className={t2}>{t3}{t7}</div>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t8) {
    t9 = <div className={t4} onClick={t5}>{t6}{t8}</div>;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
export default DocumentItem;